import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { CacheService } from '../services/cache.service';

@Injectable({
    providedIn: 'root',
})
export class CacheRunService {
    constructor (
        private monEvents: MonEventService,
        private cacheService: CacheService,
    ) {}

    initializeApp (): void {
        this.monEvents.addListener('logout', () => {
            this.cacheService.clearCache('users');
        });
    }
}
